"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataSourceTypes = void 0;
var DataSourceTypes;
exports.DataSourceTypes = DataSourceTypes;
(function (DataSourceTypes) {
  DataSourceTypes["Dictionary"] = "dictionary";
  DataSourceTypes["DictionaryConfig"] = "dictionaryConfig";
  DataSourceTypes["Organization"] = "organization";
})(DataSourceTypes || (exports.DataSourceTypes = DataSourceTypes = {}));